import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Content from 'components/shared/Content'
import Heading from 'components/shared/Heading'
import Section from 'components/shared/Section'
import { ReactComponent as Warsaw } from 'assets/icons/warsaw.svg'
import { ReactComponent as Berlin } from 'assets/icons/berlin.svg'
import { ReactComponent as Cracow } from 'assets/icons/krakow.svg'
import { ReactComponent as Leipzig } from 'assets/icons/lipsk.svg'
import { ReactComponent as Gdynia } from 'assets/icons/gdynia.svg'

const Wrapper = styled.section`
  position: relative;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.gray200};
  overflow: hidden;
  ${({ theme }) => theme.mq.lg} {
    padding: 40px 0;
  }
`
const StyledContent = styled(Content)`
  max-width: 1800px;
`

const MapsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 30px;
  padding-top: 50px;
  ${({ theme }) => theme.mq.lg} {
    padding-top: 100px;
    grid-template-columns: repeat(2, 1fr);
  }
`

const MapWrapper = styled.div`
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.white};
  padding: 80px 0 20px;
  box-shadow: 0 0 30px -10px rgba(0, 0, 0, 0.3);
  transition: 0.3s;
  color: ${({ theme }) => theme.colors.dark};
  transform: scale(0.99);
  @media (hover: hover) {
    &:hover {
      transform: scale(1);
    }
  }
`

const HeadingWrapper = styled.div`
  position: absolute;
  top: 35px;
  left: 35px;
`

const ImageWrapper = styled.div`
  width: 100%;
  padding: 10px;
  height: 250px;
  ${({ theme }) => theme.mq.xs} {
    height: 350px;
  }
  ${({ theme }) => theme.mq.s} {
    height: 450px;
  }
  ${({ theme }) => theme.mq.md} {
    height: 550px;
  }
  ${({ theme }) => theme.mq.xl} {
    height: 600px;
  }
  svg {
    width: 100%;
    height: 100%;
  }
`

const getMap = city => {
  switch (city.toLowerCase()) {
    case 'warsaw':
      return <Warsaw />
    case 'cracow':
      return <Cracow />
    case 'leipzig':
      return <Leipzig />
    case 'berlin':
      return <Berlin />
    case 'gdynia':
      return <Gdynia />
    default:
      return null
  }
}

const Map = ({ maps }) => (
  <Wrapper id="experience">
    <Section>
      <StyledContent>
        <Heading center big title="Group" highlight="experience" />
        <MapsWrapper>
          {maps.map(({ title, link }) => (
            <MapWrapper
              as={link ? 'a' : 'div'}
              key={title}
              href={link}
              target="_blank"
            >
              <HeadingWrapper>
                <Heading title={title} />
              </HeadingWrapper>
              <ImageWrapper>{getMap(title)}</ImageWrapper>
            </MapWrapper>
          ))}
        </MapsWrapper>
      </StyledContent>
    </Section>
  </Wrapper>
)

Map.propTypes = {
  maps: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default Map
